import { render, staticRenderFns } from "./ProfilView.vue?vue&type=template&id=242b2867&"
import script from "./ProfilView.vue?vue&type=script&lang=js&"
export * from "./ProfilView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports